module.exports = __webpack_public_path__ + "8b4a27b8bdcec2aac475d82e8e727339.png";